export default __webpack_public_path__ + "static/media/css.b0696b45.svg";